export default __webpack_public_path__ + "static/IBMPlexSans-Bold-83d898b34855078ceedcfeed74b36193.woff2";